import { create } from 'zustand'

interface InsufficientCreditsState {
  open: boolean
  requiredCost: number
  currentBalance: number
  /** Billing mode of the org that was short ('team_tab' disables personal purchases). Undefined = personal. */
  billingMode?: string
  trigger: (cost: number, balance: number, billingMode?: string) => void
  close: () => void
}

export const useInsufficientCreditsStore = create<InsufficientCreditsState>(set => ({
  open: false,
  requiredCost: 0,
  currentBalance: 0,
  billingMode: undefined,
  trigger: (cost, balance, billingMode) =>
    set({ open: true, requiredCost: cost, currentBalance: balance, billingMode }),
  close: () => set({ open: false }),
}))

// Dev/E2E affordance: open the modal at any shortfall without spending olives on
// a real generation. Mirrors window.__martiniCanvasTest; stripped from prod
// bundles (guarded on NODE_ENV), so it never ships to users.
if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
  ;(
    window as unknown as {
      __martiniCreditsTest?: { open: (cost: number, balance: number, billingMode?: string) => void }
    }
  ).__martiniCreditsTest = {
    open: (cost, balance, billingMode) => useInsufficientCreditsStore.getState().trigger(cost, balance, billingMode),
  }
}
